<div class="removal-panel">
  <div class="text-selected">
    <span>{{count}} {{type}}</span> {{ "COMMUNICATIONS.RemovalPanel_Selected" | translate }}
  </div>
  <ion-button (click)="remove()"
              color="danger">{{"COMMUNICATIONS.RemovalPanel_Delete_Selected" | translate}}</ion-button>
</div>
